module.exports = __webpack_public_path__ + "img/open_new_tab.bd76f984.png";